<template>
  <div v-if="isLoading" class="d-flex justify-content-center align-items-center" style="height: 300px;">
    <span>{{ $t("loading") }}</span>
  </div>
  <apexchart
    v-else
    type="polarArea"
    width="100%"
    :options="topSellingProductsChart"
    :series="products"
  ></apexchart>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import type { DashboardTopProductItem } from "@/services/dashboard";

export default defineComponent({
  name: "TopSellingProductsChart",
  props: {
    items: {
      type: Array as () => DashboardTopProductItem[],
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const products = computed(() => props.items.map((item) => Number(item.sold_qty || 0)));
    const topSellingProductsChart = computed(() => ({
      chart: {
        width: "100%",
        type: "polarArea",
        offsetX: 0,
        offsetY: 0,
      },
      stroke: {
        width: 0,
        colors: undefined,
      },
      yaxis: {
        show: false,
      },
      fill: {
        opacity: 1,
      },
      colors: ["#B142E1", "#EA5BE6", "#7A2CB2", "#7E32C4", "#FC7483"],
      labels: props.items.map((item) => item.product_name),
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
        floating: false,
        fontSize: "14px",
        fontWeight: 500,
        inverseOrder: false,
        offsetX: 0,
        offsetY: 0,
        labels: {
          colors: "#838A95",
        },
        markers: {
          width: 16,
          height: 16,
          radius: 2,
          offsetX: 0,
          offsetY: 0,
        },
      },
      plotOptions: {
        polarArea: {
          rings: {
            strokeWidth: 0,
          },
          spokes: {
            strokeWidth: 0,
          },
        },
      },
    }));

    return {
      products,
      topSellingProductsChart,
    };
  },
});
</script>
